<template>
    <div id='forgotten-page-container' class='container-fluid page'>
        <div class='row'>
            <div class='col-sm-8 col-md-6 col-lg-4 mx-auto'>
                <div class='card card-signin my-5'>
                    <div class='card-body'>
                        <h5 class='card-title text-center'><span class='icon-lock'></span> Mot de passe oublié</h5>
                        <form novalidate action='#' @submit.prevent='send'>
                            <div class='form-group row' style='min-height:60px;'>
                                <div class='col-sm-12'>
                                    <input type='email' class='form-control' id='email'
                                           placeholder='Entrez votre Email'
                                           onfocus="this.placeholder=''"
                                           onblur="this.placeholder='Entrez votre Email'" v-model='email'
                                           :class="[{'form-control':true, 'is-invalid' : !validEmail(email) && blur_email},{'form-control':true, 'is-valid' : validEmail(email) && blur_email}]"
                                           v-on:blur='blur_email = true'/>
                                    <div class='invalid-feedback'>
                                        {{ error_email }}
                                    </div>
                                    <div class='valid-feedback'>
                                        Email valide.
                                    </div>
                                </div>
                            </div>
                            <div class='form-group row'>
                                <div class='col-sm-12 input-group'>
                                    <button class='btn btn-lg btn-primary btn-block text-uppercase' type='submit'>
                                        <span class='icon-signin'></span> Récupérer
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class='row' style='text-align: center;'>
                            <div class='col-6'>
                                <router-link :to="{ name: 'login' }">Se connecter</router-link>
                            </div>
                            <div class='col-6'>
                                <router-link :to="{ name: 'register' }">S'inscrire</router-link>
                            </div>
                        </div>
                        <div id='loader-container'>
                            <PulseLoader :loading='loading' :color='color' :size='size'></PulseLoader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        name: 'forgotten-password',
        components: {
            PulseLoader
        },
        computed: {
            valid: function () {
                return this.valid_email;
            }
        },
        data() {
            return {
                user_manual_link: 'src/public/doc/Credicys - documentation utilisateur non connecte.pdf?' + Date.now(),
                //Component intern props
                email: '',
                valid_email: false,
                error_email: '',
                blur_email: false,
                //error
                user_not_registrered:'',
                auth_not_active:'',
                //success
                auth_verified: false,
                //PulseLoader props
                loading: false,
                color: '#d93752',
                size: '1em'
            }
        },
        methods: {
            validate: function () {
                this.blur_email = true;
                if (this.validEmail(this.email)) {
                    this.valid_email = true;
                } else {
                    this.valid_email = false;
                }
            },
            validEmail: function (email) {
                var re = /(.+)@(.+){2,}\.(.+){2,}/;

                if (!re.test(email.toLowerCase())) {
                    this.error_email = 'Merci de renseigner un email valide.';
                    return false;
                }

                if(this.user_not_registrered == email) {
                    this.error_email = 'Aucun compte ne correspond à cet Email.';
                    return false;
                }

                if(this.auth_not_active == email) {
                    this.error_email = 'Ce compte n\'est pas actif.';
                    return false;
                }

                return true;
            },
            send: function () {
                this.validate();
                if (this.valid) {
                    this.loading = true;
                    this.$store.dispatch('postApi', {
                        'controller':'PCAuth',
                        'action':'forgotPassword',
                        'post': {
                            email: this.email
                        }
                    }).then(response => {
                        this.loading = false
                        if(response.data.error === 'auth_not_active') {
                            this.auth_not_active = this.email;
                        }else if(response.data.error === 'user_not_registrered') {
                            this.user_not_registrered = this.email;
                        }else {
                            this.loading = false;
                            this.$router.push({name: 'forgotten-password-success'});
                        }
                    })
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/ForgottenPassword.vue